import { crudMdActions } from "@/services/CrudMdActions";

// Hours per month imported from Toggl (tab of the project edit view)
export default {
  name() {
    return "proyectos-horas-mes";
  },
  ...crudMdActions("proyectos-horas-mes"),
};
